import Toolbar from '@material-ui/core/Toolbar';
import {withStyles} from '@material-ui/styles';
import React from 'react';
import {SaveButton} from '../../controlComponents';

const loginFormToolbarStyles = {
    toolbarStyles: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 48,
        padding: 0,
        paddingTop: 16,
    },
    buttonClassName: {},
};

const LoginFormToolbar = withStyles(loginFormToolbarStyles)(({
    handleSubmitWithRedirect,
    classes,
    buttonLabel,
    ...rest
}) => {
    return (
        <Toolbar className={classes.toolbarStyles}>
            <SaveButton
                {...rest}
                noIcon
                fullWidth
                className={classes.buttonClassName}
                handleSubmitWithRedirect={handleSubmitWithRedirect}
                saveButtonLabel={buttonLabel}
            />
        </Toolbar>
    );
});

export default LoginFormToolbar;
